import { createApp } from 'vue';
import { createGtm } from '@gtm-support/vue-gtm';
import axios from 'axios';
import * as Components from './_components';

const appContainers = document.querySelectorAll('.vue-app');

const initVueApp = (appContainer) => {
  const app = createApp({});
  axios.get('/get/gtm-key')
    .then((response) => {
      var gtmKey = response.data;
      if (gtmKey.length) {
        app.use(
          createGtm({
            id: gtmKey,
            defer: true,
            compatibility: true,
            debug: false,
          })
        );
      }
    })
    .catch((error) => {
      console.log(error);
    })
    .finally(() => {
      if (app.config) {
        app.config.devtools = true;
        app.config.productionTip = false;
        app.config.window = window;
      }
      // Register components globally
      Components.default(app);
      app.mount(appContainer);
    });
};

appContainers.forEach((appContainer, index) => {
  initVueApp(appContainer);

  // Signal that all Vue apps have been loaded
  if (index === appContainers.length - 1) {
    const vueInitEvent = new Event('vue-initialized');
    const body = document.querySelector('body');
    body.dispatchEvent(vueInitEvent);
  }
});

document.addEventListener("DOMContentLoaded", function () {
  if (typeof $telerik !== 'undefined') {
    // eslint-disable-next-line
    $telerik.$(document).on('modalDialogClosed', () => {
      setTimeout(() => {
        const newAppContainers = document.querySelectorAll('.vue-app');

        newAppContainers.forEach((appContainer) => {
          if (!appContainer.hasAttribute('data-v-app')) {
            initVueApp(appContainer);
          }
        });
      }, 2000);
    });
  }
});
